import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { ThemeSelector } from '../components';

const splashLight = require('../assets/images/coinmend-splash-light.png');
const splashDark = require('../assets/images/coinmend-splash-dark.png');

const Head = styled.div`
  display: flex;
  height: 50px;
  background: ${props => props.theme.bg};
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 5px;
  color: ${props => props.theme.top.title};
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
`;

const Logo = styled.img`
  height: 20px;
  margin-left: 20px;
`;

const TopBar = ({ theme, selectTheme, selectedTheme }) => (
  <ThemeProvider theme={theme}>
    <Head>
      <Left>
        <Logo src={theme.base === 'light' ? splashDark : splashLight} alt="" />
      </Left>
      <Right>
        <ThemeSelector selectTheme={selectTheme} selectedTheme={selectedTheme} />
      </Right>
    </Head>
  </ThemeProvider>
);

export default withTheme(TopBar);



// WEBPACK FOOTER //
// ./src/components/TopBar.js